<div class="checkbox-filter-container" *ngIf="!!options?.length">
  <app-box-filter
    [individualFilter]="individualFilter"
    [index]="index"
    [label]="noTranslate ? label : (label | transloco)"
    [show]="isOpenBox"
    (toggleShow)="toggleCheckboxOptions()">
    <div class="list-container" [class.active]="isOpenBox">
      <div class="checkbox-list" 
        [class.full-view]="isFullView" 
        [class.individual-view]="individualFilter"
        [class.expanded-view]="isExpandedView">
        <ng-container *ngFor="let item of options; index as optionId">
          <div class="checkbox">
            <app-ds-checkbox
              [checked]="checked(item)"
              [isDisabled]="isDisabled(item)"
              [title]="{ 
                Label: isStops ? (item.Label | stopName | transloco) :
                       isMultipleCarriers(item) ? (carrierLabel | transloco) :
                       isActivityTypes ? (getActivityTypeLabel(item.Text) | transloco) :
                       (item.Label | transloco) || getCheckboxLabel(item)}"
              [align]="checkboxAlign"
              [image]="item.Image"
              [counter]="item.Count"
              [tagRating]="getRatingTagLabel(item.Text)"
              (checkboxOnChecked)="select(item)">
            </app-ds-checkbox>
          </div>
        </ng-container>
      </div>
      <div class="see-more-cont" *ngIf="seeMoreActive">
        <div class="see-more" (click)="toggleMoreFliters()">
          <app-ds-typography
            [fontFamily]="fontFamily.SemiBold"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="(!seeMore ? 'SEE_MORE' : 'SEE_LESS') | transloco">
          </app-ds-typography>
        </div>
      </div>
    </div>
  </app-box-filter>
</div>
